import { render, staticRenderFns } from "./quotationClientPopup.vue?vue&type=template&id=fb2a74c0&"
import script from "./quotationClientPopup.vue?vue&type=script&lang=js&"
export * from "./quotationClientPopup.vue?vue&type=script&lang=js&"
import style0 from "./quotationClientPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb2a74c0')) {
      api.createRecord('fb2a74c0', component.options)
    } else {
      api.reload('fb2a74c0', component.options)
    }
    module.hot.accept("./quotationClientPopup.vue?vue&type=template&id=fb2a74c0&", function () {
      api.rerender('fb2a74c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/components/quotationClientPopup.vue"
export default component.exports